// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3lnef","notes":"Notes_notes__32T6D"};